var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot"},[_c('div',[_vm._v(_vm._s(_vm.config.page_bottom))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.config.rights_reserved)}})])}
var staticRenderFns = []

export { render, staticRenderFns }